import { Droplets, Scale, TrendingUp, Leaf, Mountain, ScanSearch } from "lucide-react"

const features = [
  {
    icon: Droplets,
    title: "Flood Risk Analysis",
    description: "Digital elevation modeling, river proximity assessment, and historical flood data overlay for comprehensive flood risk scoring.",
  },
  {
    icon: Scale,
    title: "Legal Risk Scan",
    description: "Automated checks against Ndung'u Commission records, gazetted lands, forest reserves, and road reserves for legal red flags.",
  },
  {
    icon: TrendingUp,
    title: "Valuation Estimates",
    description: "Market-comparable pricing analysis with infrastructure proximity scoring and overpayment risk detection.",
    pro: true,
  },
  {
    icon: ScanSearch,
    title: "Satellite Imagery",
    description: "High-resolution satellite views showing land use, neighboring developments, and terrain characteristics.",
  },
  {
    icon: Leaf,
    title: "Environmental Index",
    description: "Air quality, heat exposure, industrial proximity, and livability scoring for informed residential planning.",
    pro: true,
  },
  {
    icon: Mountain,
    title: "Slope Assessment",
    description: "Terrain gradient analysis and buildability classification to identify construction challenges before purchase.",
  },
]

export function FeaturesGrid() {
  return (
    <section id="features" className="border-b border-border bg-muted/30 py-20">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="text-center">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Comprehensive Risk Intelligence
          </h2>
          <p className="mt-3 text-pretty text-muted-foreground">
            Every critical factor analyzed in one unified report
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group relative rounded-xl border border-border bg-card p-6 transition-shadow hover:shadow-md"
            >
              {feature.pro && (
                <span className="absolute right-4 top-4 rounded-full bg-primary/10 px-2.5 py-0.5 text-[10px] font-semibold text-primary">
                  PRO
                </span>
              )}
              <div className="flex size-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <feature.icon className="size-5" />
              </div>
              <h3 className="mt-4 font-semibold text-foreground">{feature.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
